import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useUser, TooltipRoot } from '@izettle/react';
import { EmailConfirmationModalOpenEventListener } from '@izettle/react-shared';
import { useConfig } from '../hooks/use-config.js';
import { getRootStyle, AppContainer } from '../styles.js';
import { getShowPayPalWidget } from '../utils/rest.js';
import { AppContainerWrap } from './app-container-wrap.js';
import { Footer } from './footer.js';
import { GlobalNotifications } from './global-notifications.js';
import { PpProfileWidget } from './pp-profile-widget.js';
import { UnsupportedBrowser } from './unsupported-browser.js';
import { VerticalNavigation } from './vertical-navigation.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useLayout } from '../hooks/use-layout.js';
import { useAuthClient } from '../hooks/use-auth.js';

const PageTemplate = _ref => {
  let {
    urls,
    footerLinks,
    onLoaded,
    children
  } = _ref;
  const history = useHistory();
  const {
    config
  } = useConfig();
  const {
    hideLayout
  } = useLayout();
  const {
    locale,
    identityProvider,
    businessIdentityProvider
  } = useUser();
  const authClient = useAuthClient();
  const [headerReady, setHeaderReady] = useState(false);
  const [footerReady, setFooterReady] = useState(false);

  // If we load the layout, wait for all of them to be loaded before calling callback
  useEffect(() => {
    if (headerReady && footerReady) {
      onLoaded();
    }
  }, [headerReady, footerReady]);

  // If we do not, just call it immediately
  useEffect(() => {
    if (hideLayout) {
      onLoaded();
    }
  }, [hideLayout]);

  // Handle VertNav's react navigation event
  useEffect(() => {
    const handler = event => {
      // We need the ? here in case there is no Router context.
      history?.push(event.detail.newUrl);
    };
    document.addEventListener("iz-bo-vertical-navigation-push-url", handler);
    return () => {
      document.removeEventListener("iz-bo-vertical-navigation-push-url", handler);
    };
  }, []);
  const paypalWidgetVisible = getShowPayPalWidget(authClient?.isImpersonatedUser, identityProvider, businessIdentityProvider);
  if (hideLayout) {
    return children;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [getRootStyle({
      paypalWidgetVisible
    }), paypalWidgetVisible && /*#__PURE__*/jsx(PpProfileWidget, {
      locale: locale.isoLocale
    }), /*#__PURE__*/jsx(VerticalNavigation, {
      urls: urls,
      setReady: setHeaderReady,
      version: config?.componentVersions?.verticalNavigation
    }), /*#__PURE__*/jsxs(AppContainerWrap, {
      children: [/*#__PURE__*/jsx(GlobalNotifications, {
        locale: locale.isoLocale,
        version: config?.componentVersions?.globalNotifications
      }), process.env.NODE_ENV !== "test" && /*#__PURE__*/jsx(EmailConfirmationModalOpenEventListener, {
        locale: locale.isoLocale
      }), /*#__PURE__*/jsxs(AppContainer, {
        children: [/*#__PURE__*/jsx(UnsupportedBrowser, {
          version: config?.componentVersions?.unsupportedBrowser
        }), /*#__PURE__*/jsx(TooltipRoot, {}), /*#__PURE__*/jsx("main", {
          children: headerReady && footerReady && children
        }), /*#__PURE__*/jsx(Footer, {
          locale: locale.isoLocale,
          onLoaded: () => setFooterReady(true),
          version: config?.componentVersions?.footer,
          links: footerLinks
        })]
      })]
    })]
  });
};

export { PageTemplate };
//# sourceMappingURL=page-template.js.map
